export var PACKAGE_VERSION = "3.0.0 (33dfd90)";
export var THEME = "open-source-visual-refresh";
export var ALWAYS_VISUAL_REFRESH = true;
